import React, { useEffect, useState } from "react";
import { Button, Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { blobURL } from "common/StringUtils";
import { useForm } from "react-hook-form";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import axios from "axios";

// Components
import Loader from "components/Loader";
import Layout from "../Layout";
import { useSelector } from "react-redux";
import { LOCALES } from "common/constants";

const HealthInsurance = ({ dashboardFooter }) => {
  const { t } = useTranslation();
  const user = useSelector((state) => state.auth.user);
  let language = localStorage.getItem("i18nextLng");
  const healthInsurance = `${blobURL}/healthinsurance.jpg`;
  const healthInsurancePdf = `${blobURL}/VälkomstbrevSjukförsäkringPlansjuk.pdf`;

  const [isLoading, setisLoading] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const noSpaces = (value) => {
    if (/^\s+|\s+$/.test(value)) {
      return t("Spaces are not allowed");
    }
    return true;
  };

  const onSubmit = async (data) => {
    try {
      setisLoading(true);
      const response = await axios.post(
        `/contactus/private-insurance-feature`,
        {
          ...data,
          lang: language,
          type: 3,
        }
      );
      if (response?.statusText === "OK") {
        setisLoading(false);
        toast.success(t(response?.data?.message));
        reset();
      }
    } catch (error) {
      setisLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const HealthComponent = () => {
    return (
      <>
        {isLoading && <Loader />}
        <Helmet>
          <title>{t("Health Insurance | Invozio")}</title>

          {language === LOCALES.EN_US ? (
            <link
              rel="canonical"
              href="https://invozio.com/health-insurance"
            />
          ) : (
            <link
              rel="canonical"
              href="https://invozio.com/sjukforsakring"
            />
          )}
          <meta name="robots" content="index, follow" />
        </Helmet>

        <Container className="p-0 self_new negotiate neg_rspn health-insurance-top-section">
          <header>
            <div className="container">
              <div className="row ">
                <div className="col-md-6 py-3">
                  <div className="d-flex align-items-center h-100">
                    <h1 className="purple px-5">{t("Health Insurance")}</h1>
                  </div>
                </div>
                <div className="col-md-6 py-3 text-right">
                  <img
                    src={healthInsurance}
                    alt="invoice-negotation"
                    className="img-fluid private-hero-img"
                  />
                </div>
              </div>
            </div>
          </header>
          <main>
            <section className="guide-section bg-white">
              <div className="container">
                <div className="py-3">
                  <div className="page-heading">
                    <h2 className="purple">{t("Health Insurance")}</h2>
                    <p>
                      {t(
                        "With this health insurance, you can feel secure knowing that you will receive financial compensation in case of long-term illness. Compensation is paid out monthly as long as you receive benefits from the Social Insurance Agency, up to the age of 67. The compensation is based on your salary and is similar to that provided under ITP (i.e., the collective agreement for salaried employees). The insurance also offers the opportunity for rehabilitative assistance and preventive health services at no cost. Send an application HERE, and we will get back to you shortly with a proposal for health insurance."
                      )}
                      <a
                        className="ml-1"
                        target="_blank"
                        href={healthInsurancePdf}
                        style={{ textDecoration: "underline" }}
                        rel="noopener noreferrer"
                      >
                        <strong>{t("Click here")}</strong>
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </section>

            <section className="guide-section even">
              <div className="container">
                <div className="py-3">
                  <div>
                    <h2 className="purple">{t("For more information:")}</h2>
                    <p style={{ marginTop: 0, marginBottom: 5 }}>
                      Staffan Segersten, Factum
                    </p>
                    <p style={{ marginTop: 0, marginBottom: 5 }}>
                      {t("Phone")}: <span>018 - 69 30 00</span>
                    </p>
                    <p style={{ marginTop: 0, marginBottom: 5 }}>
                      {t("Email")} : <span>staffan.segersten@factum.nu</span>{" "}
                    </p>
                  </div>
                  <h2 className="purple">{t("Request a Quote")}</h2>
                  <p style={{ margin: 0 }}>
                    {t(
                      "Are you interested in taking out private health insurance through Invozio? Fill in your details below, and we will contact you with a quote and application forms."
                    )}
                  </p>

                  <div className="container">
                    <div className="contact-form-wrap new-form-width mx-auto">
                      <form
                        className="w-100 p-4 m-auto text-center bg-light rounded-1"
                        onSubmit={handleSubmit(onSubmit)}
                      >
                        <div className="d-flex flex-column mb-3 flex-xs-column">
                          <input
                            type="text"
                            className={`form-control w-100 ${
                              errors.firstName ? "is-invalid" : ""
                            }`}
                            placeholder={t("First name")}
                            {...register("firstName", {
                              required: "First name is required",
                              minLength: {
                                value: 3,
                                message: "First name must be at least 3 char",
                              },
                              validate: noSpaces,
                            })}
                          />
                          {errors.firstName && (
                            <div className="invalid-feedback text-left">
                              <span>{t(errors.firstName.message)}</span>
                            </div>
                          )}
                        </div>
                        <div className="d-flex flex-column mb-3 flex-xs-column">
                          <input
                            type="text"
                            className={`form-control w-100 ${
                              errors.lastName ? "is-invalid" : ""
                            }`}
                            placeholder={t("Last name")}
                            {...register("lastName", {
                              required: "Last name is required",
                              minLength: {
                                value: 3,
                                message: "Last name must be at least 3 char",
                              },
                              validate: noSpaces,
                            })}
                          />
                          {errors.lastName && (
                            <div className="invalid-feedback text-left">
                              <span>{t(errors.lastName.message)}</span>
                            </div>
                          )}
                        </div>
                        <div className="d-flex flex-column mb-3 flex-xs-column">
                          <input
                            type="text"
                            className={`form-control w-100 ${
                              errors.email ? "is-invalid" : ""
                            }`}
                            placeholder={t("Email")}
                            {...register("email", {
                              required: "Email is required",
                              pattern: {
                                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                message: "Invalid email address",
                              },
                            })}
                          />
                          {errors.email && (
                            <div className="invalid-feedback text-left">
                              <span>{t(errors.email.message)}</span>
                            </div>
                          )}
                        </div>
                        <div className="d-flex flex-column mb-3 flex-xs-column">
                          <input
                            type="number"
                            className={`form-control w-100 ${
                              errors.ssn ? "is-invalid" : ""
                            }`}
                            placeholder={t("SSN number")}
                            {...register("ssn", {
                              required: "SSN number is required",
                              minLength: {
                                value: 10,
                                message:
                                  "SSN number must be at least 10 digits long",
                              },
                              maxLength: {
                                value: 15,
                                message: "SSN number cannot exceed 15 digits",
                              },
                            })}
                          />
                          {errors.ssn && (
                            <div className="invalid-feedback text-left">
                              <span>{t(errors.ssn.message)}</span>
                            </div>
                          )}
                        </div>
                        <div className="d-flex flex-column mb-3 flex-xs-column">
                          <input
                            type="text"
                            className={`form-control w-100 ${
                              errors.address ? "is-invalid" : ""
                            }`}
                            placeholder={t("Address")}
                            {...register("address", {
                              required: "Address is required",
                              minLength: {
                                value: 3,
                                message: "Address must be at least 5 char",
                              },
                              validate: noSpaces,
                            })}
                          />
                          {errors.address && (
                            <div className="invalid-feedback text-left">
                              <span>{t(errors.address.message)}</span>
                            </div>
                          )}
                        </div>

                        <Button
                          variant="primary send_contactus"
                          type="submit"
                          className="mt-2 text-light new_theme_btn"
                          size="lg"
                          style={{ backgroundColor: "#886cc1" }}
                          disabled={isLoading}
                        >
                          {t("Submit")}
                        </Button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
        </Container>
      </>
    );
  };

  return (
    <>
      {user ? (
        <Layout className="my-customers-table" showSidebar bgcolor>
          {HealthComponent()}
        </Layout>
      ) : (
        <Layout
          className="p-0 my-customers-table"
          dashboardFooter={dashboardFooter}
        >
          {HealthComponent()}
        </Layout>
      )}
    </>
  );
};

export default HealthInsurance;
